/** Provider workspace cohort; controlled readers retain case-level authority. */
export const GRIEVANCE_HANDLER_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'OWNER',
  'CEO',
  'HR_DIRECTOR',
  'OPERATIONS_DIRECTOR',
  'HR_OFFICER',
  'FACILITY_MANAGER',
  'REGION_MANAGER',
] as const;
